const o = () => {
  const e = document.querySelector(".grecaptcha-badge");
  e && e.parentNode && document.body.removeChild(e.parentNode);
};
export {
  o as removeGoogleReCaptchaBadge
};
//# sourceMappingURL=removeGoogleReCaptchaBadge.js.map
